import React, { Component,Fragment} from 'react';
import "./loader.css";

class Loader extends Component {
  render() {
    return (
      <Fragment>
        <div className="loader" style={{
          border: "16px solid #f3f3f3",
          borderRadius: "50%",
          borderTop: "16px solid green",
          width: "190px",
          height: "190px",
          WebkitAnimation: "spin 1s linear infinite",
          SafariAnimation: "spin 1s linear infinite",
        }}>
        </div>
        <div className="still" style={{
          zIndex: "10",
          marginTop: "-105px",
          marginLeft: "35px",
          color: "green",
          width: "150px",
        }}>        
        UVM Loading ...
        </div>
      </Fragment>
    );
  }
}

export default Loader;
